module.exports = __webpack_public_path__ + "img/OBUHomePage_04.fa38fbb6.png";